// 员工管理路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/sucai',
  component: Layout,
  children: [
    {
      path: 'index',
      component: () => import('@/view/library/index'),
      name: '素材管理'
    },
    {
      path: 'index',
      component: () => import('@/view/library/index'),
      name: '素材管理'
    }
  ]
}
